export default __webpack_public_path__ + "static/media/dedicated-icon.02985f7c.svg";